import {
  ACCESSIBILITY_ARGS,
  COMPONENT_STATE_ARGS,
  INPUT_MENU_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { ROLE_MENU, ROLE_MENUITEM } from '../../../../../utils/spds/constants/aria';
import { hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from './menu-item.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Menu component for dropdown buttons',
  extends: [
    pick(ACCESSIBILITY_ARGS, ['ariaLabelledBy']),
    pick(COMPONENT_STATE_ARGS, ['open', { name: 'animated', default: true }, 'id']),
    pick(MENU_ARGS, ['anchorElement', 'toggleOpenState']),
    pick(INPUT_MENU_ARGS, ['noResultsText', 'searchable', 'searchPlaceholder', 'searchThreshold']),
  ],
  name: 'Dropdown Menu',
});

export default class SpdsActionButtonDropdownMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  get animated() {
    return this.argOrDefault('animated');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{this.animated}}
      @ariaLabelledBy={{@ariaLabelledBy}}
      @id={{@id}}
      @noResultsText={{@noResultsText}}
      @open={{@open}}
      @role={{ROLE_MENU}}
      @searchable={{@searchable}}
      @searchPlaceholder={{@searchPlaceholder}}
      @searchThreshold={{@searchThreshold}}
      data-test-spds-action-button-dropdown-menu
      {{this.validateArguments}}
    >
      {{yield
        (hash
          Item=(component
            MenuItem showSelectedStyles=false role=ROLE_MENUITEM toggleOpenState=@toggleOpenState
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_DROPDOWN_MENU_METADATA = SpdsActionButtonDropdownMenu.metadata;
